import { render, staticRenderFns } from "./ConnectedPost.vue?vue&type=template&id=04f46f4e&"
import script from "./ConnectedPost.vue?vue&type=script&lang=js&"
export * from "./ConnectedPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports